module.exports = __webpack_public_path__ + "static/media/e-ride-icon.cb2d3387.svg";